import { Vector2 } from "../../common/vector2.js";
import type { DailyTaskRewardDto } from "../../api/dto/daily_tasks.dto.js";
import { dailyTaskRewardIcon } from "../common_ui_elements/reward_icon.js";
import type { RewardFlySource } from "./reward_fly_to_hud.js";
import { UIElement } from "../common_ui_elements/ui_element.js";

export class RewardFlySources
{
  private static readonly MAX_HEART_COPIES = 3;

  static fromReward( reward: DailyTaskRewardDto, center: Vector2, size: number ): RewardFlySource
  {
    const is_heart = reward.type === "heart" || reward.type === "infinite_hearts";
    const copies = reward.type === "heart" ? Math.max( 1, Math.min( RewardFlySources.MAX_HEART_COPIES, reward.amount ) ) : 1;

    return {
      target: reward.type === "coin" ? "coin" : is_heart ? "heart" : "avatar",
      img_id: dailyTaskRewardIcon( reward.type ),
      center,
      size,
      amount: reward.amount,
      copies,
    };
  }

  static fromElement( reward: DailyTaskRewardDto, element: UIElement ): RewardFlySource
  {
    const rect = element.getRect();
    const position = element.getAbsolutePosition();
    const center = new Vector2( position.x + rect.getW() / 2, position.y + rect.getH() / 2 );

    return RewardFlySources.fromReward( reward, center, Math.min( rect.getW(), rect.getH() ) );
  }
}
